import { createTheme } from "@mui/material";

/**
 * Reusable theme and class names for Autocomplete components
 */

export const getAutocompleteOptionClasses = (
  isMobile?: boolean,
  isSelected?: boolean
) => {
  const baseClasses = "px-4 py-2 mx-1 rounded-md hover:bg-[#FFF8C9]";
  const selectedClasses = isSelected ? "bg-[#FFF3A5]" : "";
  const mobileClasses = isMobile ? "border-b border-gray-200" : "";

  return `${baseClasses} ${selectedClasses} ${mobileClasses}`.trim();
};

export const getAutocompleteTheme = (
  isMobile?: boolean,
  withPlaceholderColor?: boolean
) => {
  return createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          paper: {
            borderRadius: "0.5rem",
            border: "1px solid #EAECF0",
            boxShadow:
              "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
          },
          listbox: {
            marginTop: "5px",
            padding: "6px",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: "10px",
              background: "#EAECF0",
            },
            "&::-webkit-scrollbar-track": {
              borderRadius: "10px",
            },
          },
          option: {
            backgroundColor: "transparent !important",
            "&:hover": {
              backgroundColor: "#FFF8C9 !important",
            },
            "&[aria-selected='true']": {
              backgroundColor: "#FFF3A5 !important",
            },
            "&.Mui-disabled": {
              backgroundColor: "#FFFFFF !important",
              color: "#9A9A9A !important",
            },
          },
          inputRoot: {
            paddingLeft: "8px !important",
            paddingRight: "8px !important",
            paddingTop: isMobile ? "2px !important" : "8px !important",
            paddingBottom: isMobile ? "2px !important" : "8px !important",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "& fieldset": {
              borderRadius: "0.5rem !important",
              "&:hover": {
                outline: "none !important",
              },
            },
            "&.Mui-focused fieldset": {
              borderColor: "#D0D5DD !important",
              borderStyle: "solid",
              borderWidth: "1px",
              boxShadow: "0px 0px 2px 2px rgba(255, 164, 0, 0.24) !important",
            },
            "&:hover fieldset": {
              borderColor: "#D0D5DD !important",
              borderStyle: "solid",
              borderWidth: "1px",
              boxShadow: "0px 0px 2px 2px rgba(255, 164, 0, 0.24) !important",
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontWeight: isMobile ? "100" : "normal",
            "&.Mui-disabled": {
              WebkitTextFillColor: "#000",
            },
            ...(withPlaceholderColor && {
              "&::placeholder": {
                color: "black",
                opacity: "1",
              },
            }),
          },
        },
      },
      MuiPopper: {
        styleOverrides: {
          root: {
            marginTop: "5px",
          },
        },
      },
    },
  });
};
